import {eraseCookie} from './cookie.js';

$('.locale-definitions a').on('click', function (e){
  e.preventDefault();

  eraseCookie('splash-page', '', -1);

  const url = e.currentTarget.href;
  window.location.href = url;
});